import CheckboxWithTooltip from "../../components/component/CheckboxWithTooltip";
import AnchorResource from "./AnchorResource";

const renderEMSCapabilities = ({ siteType, gridSettings, informationToolTIP, handleOnGridFeatureChange, useCases }) => {
    return (<>
        {
            useCases?.useCases?.["Ems capabilities"]?.includes("Remote energy monitoring") && (
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-1">
                    <CheckboxWithTooltip

                        id="remoteEnergyMonitoring"
                        name="remoteMonitoringControl"
                        label="Remote energy monitoring"
                        checked={ gridSettings?.remoteMonitoringControl}
                        value={gridSettings?.remoteMonitoringControl}
                        onChange={siteType === "OFF_GRID"?handleOnGridFeatureChange:() => { }}
                        tooltipInfo={informationToolTIP?.remoteMonitoringMGassTooltipData}

                    />
                </div>)
        }
        {
            useCases?.useCases?.["Ems capabilities"]?.includes("Energy optimization") && (
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-1">
                    <CheckboxWithTooltip
                        id="energyOptimaztion"
                        name="energyOptimaztion"
                        label="Energy optimization"
                        checked={gridSettings?.staticTariffBased || gridSettings?.dynamicTariffBased ? true :gridSettings?.energyOptimaztion}
                        value={gridSettings?.energyOptimaztion}
                        onChange={handleOnGridFeatureChange}
                        tooltipInfo={informationToolTIP?.energyOptimaztionTooltipData}

                    >
                        {
                            useCases?.useCases?.["Energy optimization"]?.includes("Static Tariff Based") && (
                                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-1 pl-4">
                                    <CheckboxWithTooltip

                                        id="staticTariffBased"
                                        name="staticTariffBased"
                                        label="Static Tariff Based"
                                        checked={gridSettings?.staticTariffBased}
                                        value={gridSettings?.staticTariffBased}
                                        onChange={handleOnGridFeatureChange}
                                        tooltipInfo={informationToolTIP?.staticTariffBasedTooltipData}
                                        disabled={!gridSettings?.energyOptimaztion ? true : false}

                                    />
                                </div>)
                        }
                        {
                            useCases?.useCases?.["Energy optimization"]?.includes("Dynamic Tariff Based") && (
                                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-1 pl-4">
                                    <CheckboxWithTooltip

                                        id="dynamicTariffBased"
                                        name="dynamicTariffBased"
                                        label="Dynamic Tariff Based"
                                        checked={gridSettings?.dynamicTariffBased}
                                        value={gridSettings?.dynamicTariffBased}
                                        onChange={handleOnGridFeatureChange}
                                        tooltipInfo={informationToolTIP?.dynamicTariffBasedTooltipData}
                                        disabled={!gridSettings?.energyOptimaztion ? true : false}

                                    />
                                </div>)
                        }
                    </CheckboxWithTooltip>

                </div>)
        }
    </>);
}

const renderPMSFeatures = ({ siteType, gridSettings, informationToolTIP, handleOnGridFeatureChange, useCases, embLabels, projectTypeValue }) => {
    return (<>
        {
            useCases?.useCases?.["PMS features"]?.includes("Import/export management") && (
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-1">
                    <CheckboxWithTooltip

                        id="exportOptimization"
                        name="exportOptimization"
                        label="Export management"
                        checked={gridSettings?.exportOptimization}
                        value={gridSettings?.exportOptimization}
                        onChange={handleOnGridFeatureChange}
                        tooltipInfo={informationToolTIP?.exportOptimizationTooltipData}

                    />
                </div>)
        }
        {( gridSettings?.mode === "NO_FUEL" || gridSettings?.mode === "FUEL_ERASER" ||( projectTypeValue === "NMGaaS ETO" && siteType === embLabels.GRID_CONNECTED ))&&
            useCases?.useCases?.["PMS features"]?.includes("BESS operating modes") && (
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-1">
                    <CheckboxWithTooltip
                        id="bessOperatingModes"
                        name="bessOperatingModes"
                        label="BESS operating modes"
                        checked={gridSettings?.bessOperatingModes}
                        value={gridSettings?.bessOperatingModes}
                        onChange={handleOnGridFeatureChange}
                        // tooltipInfo={informationToolTIP?.bessOperatingModesTooltipData}

                    >
                        {
                            useCases?.useCases?.["BESS operating modes"]?.includes("Unrestricted") && (
                                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-1 pl-4">

                                    <AnchorResource
                                        id="unrestricted"
                                        name="bessOperatingModeType"
                                        label="Unrestricted"
                                        value="unrestricted"
                                        checked={gridSettings?.bessOperatingModeType === "unrestricted" ? true : false}
                                        onChange={handleOnGridFeatureChange}
                                        tooltipContent={informationToolTIP?.bessModeUnrestrictedTooltipData}
                                        disabled={!gridSettings?.bessOperatingModes ? true : false}
                                    />
                                </div>)
                        }
                        {
                            useCases?.useCases?.["BESS operating modes"]?.includes("Restricted") && (
                                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-1 pl-4">

                                    <AnchorResource
                                        id="restricted"
                                        name="bessOperatingModeType"
                                        label="Restricted"
                                        value="restricted"
                                        checked={gridSettings?.bessOperatingModeType === "restricted" ? true : false}
                                        onChange={handleOnGridFeatureChange}
                                        tooltipContent={informationToolTIP?.bessModeRestrictedTooltipData}
                                        disabled={!gridSettings?.bessOperatingModes ? true : false}
                                    />
                                </div>)
                        }
                    </CheckboxWithTooltip>
                </div>)
        }
        { !gridSettings?.atsEnable &&
            useCases?.useCases?.["PMS features"]?.includes("Load management") && (
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-1">
                    
                    <CheckboxWithTooltip
                        id="loadManagement"
                        name="loadManagement"
                        label="Load management"
                        checked={gridSettings?.loadManagement}
                        value={gridSettings?.loadManagement}
                        onChange={handleOnGridFeatureChange}
                        tooltipInfo={informationToolTIP?.loadManagementTooltipData}
                        contentStyle = {{whiteSpace: "pre-line"}}
                        
                    >
                    </CheckboxWithTooltip>
                </div>)
        }
        {
            useCases?.useCases?.["PMS features"]?.includes("Anti islanding detection") && (
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-1">
                    <CheckboxWithTooltip
                        id="antiIslandingDetection"
                        name="antiIslandingDetection"
                        label="Anti islanding detection"
                        checked={gridSettings?.antiIslandingDetection}
                        value={gridSettings?.antiIslandingDetection}
                        onChange={handleOnGridFeatureChange}
                        tooltipInfo={informationToolTIP?.antiIslandingDetectionTooltipData}

                    />
                </div>)
        }
    </>);
}

export { renderEMSCapabilities, renderPMSFeatures }